import { render, staticRenderFns } from "./special-detail.vue?vue&type=template&id=57d1ca11&scoped=true&"
import script from "./special-detail.vue?vue&type=script&lang=js&"
export * from "./special-detail.vue?vue&type=script&lang=js&"
import style0 from "./special-detail.vue?vue&type=style&index=0&id=57d1ca11&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d1ca11",
  null
  
)

export default component.exports